import request from "@/utils/request";

// 创建五馆研学活动
export const createExcursion = (data) => {
    return request({
        url: "/businessservice/excursion/create",
        method: "post",
        data: data
    })
}

// 更新五馆研学活动
export const updateExcursion = (data) => {
    return request({
        url: "/businessservice/excursion/update",
        method: "post",
        data: data
    })
}

// 分页查询五馆研学活动
export const pageExcursion = (data) => {
    return request({
        url: "/businessservice/excursion/page",
        method: "post",
        data: data
    })
}

// 查询五馆研学活动信息
export const  infoExcursion =(query) =>{
    return request({
        url: "/businessservice/excursion/info",
        method:"get",
        params: query
    })
}

// 删除五馆研学活动信息
export const  deleteExcursion =(query) =>{
    return request({
        url: "/businessservice/excursion/delete",
        method:"get",
        params: query
    })
}


// 上传五馆研学活动
export const  excursionUpload =(data) =>{
    return request({
        url: "/businessservice/excursion/uploadFile",
        method:"post",
        ContentType:'multipart/form-data',
        data: data
    })
}